import React from "react";
import DOMPurify from "dompurify";
import Markdown from "markdown-to-jsx";
import styles from "./EventDescription.module.css";

const EventDescription = ({ description }) => {
  // 1. Convert <br> tags to Markdown line-breaks
  // 2. Sanitize everything else with DOMPurify
  const sanitized = DOMPurify.sanitize(
    description.replace(/<br\s*\/?>/gi, "\n\n"),
    {
      // Only allow basic Markdown tags; strip out scripts, event-handlers, etc.
      USE_PROFILES: { html: false }
    }
  );

  return (
    <div className={styles.description_wrap}>
      <h2>DESCRIPTION</h2>
      {/* 3. Disable raw-HTML parsing so that any leftover HTML is escaped */}
      <Markdown options={{ disableParsingRawHTML: true }}>
        {sanitized}
      </Markdown>
    </div>
  );
};

export default EventDescription;